import Application from "../../Application";
import ChangePasswordPresenter, {
  IChangePasswordPresenter,
  TPasswordChangePresentationModel
} from "../../presenter/authentication/ChangePasswordPresenter";

export default class ShowResetPasswordInteractor {
  private application: Application;
  private output?: IChangePasswordPresenter;

  constructor(application) {
    this.application = application;
  }

  execute() {
    this.output = ChangePasswordPresenter({
      application: this.application,
      initialState: {
        passwordPresentationModel: {
          oldPassword: ""
        } as TPasswordChangePresentationModel,
        validationPasswordErrors: {},
        isChangeButtonDisabled: false,
        username: "",
        isPasswordExpired: false
      }
    });

    return this.output;
  }
}
